import { csrfHeaders, handleJson, jsonHeaders } from "@/lib/json-request"
import type { SceneLayoutState } from "@/lib/location-scene-3d/scene-state"

function faceUrl(projectId: number, scene3dId: number, action: string) {
  return `/projects/${projectId}/workspace/library/scene3ds/${scene3dId}/scene_face_materials/${action}`
}

export async function uploadSceneFace(projectId: number, scene3dId: number, faceKey: string, file: File) {
  const body = new FormData()
  body.append("face_key", faceKey)
  body.append("file", file)
  const res = await fetch(faceUrl(projectId, scene3dId, "upload"), {
    method: "POST",
    headers: csrfHeaders(),
    credentials: "same-origin",
    body,
  })
  return handleJson<SceneLayoutState>(res)
}

export async function assignSceneFaceFromLibrary(
  projectId: number,
  scene3dId: number,
  faceKey: string,
  source: { entity_type: string; entity_id: number; state_id?: string },
) {
  const res = await fetch(faceUrl(projectId, scene3dId, "from_library"), {
    method: "POST",
    headers: jsonHeaders(),
    credentials: "same-origin",
    body: JSON.stringify({ face_key: faceKey, source }),
  })
  return handleJson<SceneLayoutState>(res)
}

export async function generateSceneFace(projectId: number, scene3dId: number, faceKey: string, prompt: string) {
  const res = await fetch(faceUrl(projectId, scene3dId, "generate"), {
    method: "POST",
    headers: jsonHeaders(),
    credentials: "same-origin",
    body: JSON.stringify({ face_key: faceKey, prompt }),
  })
  return handleJson<SceneLayoutState>(res)
}

export async function clearSceneFace(
  projectId: number,
  scene3dId: number,
  faceKey: string,
  tiles?: ReadonlyArray<{ u: number; v: number }>,
) {
  const res = await fetch(faceUrl(projectId, scene3dId, "clear"), {
    method: "DELETE",
    headers: jsonHeaders(),
    credentials: "same-origin",
    body: JSON.stringify({ face_key: faceKey, ...(tiles ? { tiles } : {}) }),
  })
  return handleJson<SceneLayoutState>(res)
}

export async function remapSceneFaces(
  projectId: number,
  scene3dId: number,
  mappings: ReadonlyArray<{ from_face_key: string; to_face_key: string }>,
  clearFaceKeys: ReadonlyArray<string> = [],
) {
  const res = await fetch(faceUrl(projectId, scene3dId, "remap"), {
    method: "POST",
    headers: jsonHeaders(),
    credentials: "same-origin",
    body: JSON.stringify({ mappings, clear_face_keys: clearFaceKeys }),
  })
  return handleJson<SceneLayoutState>(res)
}
